var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"businessCardIframe",attrs:{"src":_vm.businessCardUrl,"title":"Business card generator","width":"100%","height":"960px"}})}
var staticRenderFns = []

export { render, staticRenderFns }